import { InterviewResultRequestCandidatePlacement } from '@core/interview-result-request-types';
import { OfferKind } from '@core/offers-types';
import { Placement } from '@core/placements-types';

const mapPlacement = (placement: Placement): InterviewResultRequestCandidatePlacement => ({
  kind: placement.offer?.kind ? OfferKind.Job : OfferKind.TalentPool,
  offerId: placement.offerId,
  stageId: placement.stageId,
  status: placement.offer?.status || placement.talentPool!.status,
  talentPoolId: placement.talentPoolId,
  title: placement.offer?.title || placement.talentPool!.title,
});

/**
 * Dashboard uses InterviewResultRequestCandidatePlacement and candidate profile uses Placement type
 * @param placements
 */
export const mapPlacements = (
  placements: Placement[],
): InterviewResultRequestCandidatePlacement[] =>
  placements.map(placement => mapPlacement(placement));
